import type { StackProps } from '@chakra-ui/react';
import { HStack, Skeleton, Text } from '@chakra-ui/react';
import { Num } from '@ui/components/Num';
import { UsdValue } from '@ui/components/Num/UsdValue';
import type { TokenConfig } from '@ui/config/token';
import type { Fraction } from 'bi-fraction';
import { useRef } from 'react';

interface GasFeeProps extends StackProps {
  data: { gasFee: Fraction; success: boolean } | undefined;
  gasTokenInfo: TokenConfig;
  gasPrice: Fraction | undefined;
  isFetching: boolean;
}

export const GasFee = ({
  data,
  gasTokenInfo,
  gasPrice,
  isFetching,
  ...props
}: GasFeeProps) => {
  const stayHidden = useRef(true);
  if (data?.success) stayHidden.current = false;
  if (data && !data.success) stayHidden.current = true;
  if (stayHidden.current) return null;

  return (
    <Skeleton loading={!data && isFetching}>
      <HStack gap="4px" {...props}>
        <Text textStyle="body2" mr="auto">
          Gas fee
        </Text>
        <Num
          decimalPlaces={gasTokenInfo.displayDecimals}
          value={data?.gasFee}
          textStyle="body2Bold"
          lineClamp={1}
          wordBreak="break-all"
        />
        {gasTokenInfo.Icon && <gasTokenInfo.Icon boxSize="16px" />}
        <UsdValue
          prefix="($"
          value={data?.gasFee}
          price={gasPrice}
          suffix=")"
          textStyle="body3"
        />
      </HStack>
    </Skeleton>
  );
};
